const convertNumbThousand = (x?: number | string): string => {
  if (!x) {
    return '0';
  }
  const num = typeof x === 'string' ? Number(x) : x;
  return num.toLocaleString('hu-HU');
};

export default convertNumbThousand;
